import styled from "styled-components";

export const $EmailWrapper = styled.div`
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
`;
